<template>
    <div class="w-full">
        <div
            class="relative border-1 rounded-2xl min-w-full min-h-[60vh] 2xl:min-h-[80vh] flex flex-col gap-2 px-2 pt-4 pb-5 border-gray-300">
            <div
                class="mobile:w-[90%] mobile:right-0 mobile:left-0 laptop:w-4/5 desktop:w-3/5 largeDesktop:w-3/6 mx-auto flex tablet:justify-end  items-center gap-2 absolute -top-6 tablet:right-6 tablet:left-auto">
                <entities :modelValue="limit" @update:modelValue="onLimitChange"
                    globalEntitiesClass="'tablet:w-[45%]'" />
                <searchInput :globalSearchClass="'mobile:w-full tablet:!w-[55%]'"
                    :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'"
                    :buttonclass="'absolute top-1.5 right-1 w-7 h-7'"
                    :img-src="require('@/assets/images/search-icon.png')"
                    :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
                    v-model="search" @input="onSearch" :onClear="onClearSearch" :readonly="loading" :clearable="true" />
                <!-- </div>
            <div class="mx-auto absolute -top-6 right-4"> -->
                <div @click="addClicked" class="w-[35px] h-[35px] cursor-pointer">
                    <img src="../../../assets/images/add-green-circle.png" alt="Add Icon" class="w-full h-full">
                </div>
            </div>
            <div v-if="list.length > 0" class="mt-2 min-h-[50vh]">
                <listings v-for="(item, index) in list" :key="index" :item="item" @click="itemClicked(item)"
                    @update="onActionClicked" />
            </div>
            <div v-else>
                <h6 class="text-center m-0 text-gray-400"
                    v-if="addresses == null || (addresses && addresses.length == 0)">
                    No Record Found
                </h6>
            </div>
        </div>
        <div
            class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
            <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
                :totalItems="totalItems" />
            <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
        </div>
    </div>

    <!-- Contractor Modal Modal -->
    <listingAddModal ref="addAffiliateModal" @update="updateList" />

</template>

<script>
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import searchInput from '../../../components/partialComponent/customInput.vue';
import entities from "../../../components/showEntities/entities.vue";
import listings from "../../../components/nest_components/omegaAffiliate/listing.vue";
import customPagination from "../../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../../components/partialComponent/pagination-entries.vue";
import listingAddModal from "../../../components/nest_components/omegaAffiliate/listingAddModal.vue";
import { useToast } from "vue-toastification";
import { status } from "nprogress";
const toast = useToast();
export default {
    components: {
        listings,
        searchInput,
        listingAddModal,
        customPagination,
        entities,
        paginationEntries
    },
    data() {
        return {
            limit: 25,
            search: "",
            page: 1,
            total_pages: 0,
            totalItems: 0,
            list: [],
            planDetails: null,
            debounceTimer: null,
            loading: false
        };
    },
    computed: {
        ...mapGetters([
            "affiliateList",
            "updateAffiliateResponse"
        ]),
    },
    watch: {
        affiliateList: function (data) {
            this.loading = false
            this.list = this.affiliateList.body
            this.total_pages = this.affiliateList.paging.total_pages
            this.totalItems = this.affiliateList.paging.total_records
        },


        updateAffiliateResponse : function (data) {
            toast.success("Updated Successfully.");
            this.updateList()
        },

    },
    mounted() {
        this.getAffiliateList({
            "search": this.search,
            "limit": this.limit,
            "page": this.page
        });
    },
    methods: {
        ...mapActions([
            "getAffiliateList",
            "updateAffiliateStatus"
        ]),

        itemClicked(data) {

        },
        updatePage(page) {
            if (page == this.page) return
            this.page = page
            this.loading = true
            this.getAffiliateList({
                "search": this.search,
                "limit": this.limit,
                "page": this.page
            });
        },
        onSearch() {
            clearTimeout(this.debounceTimer);
            // Start new debounce timer

            this.page = 1
            this.debounceTimer = setTimeout(() => {
                if (this.search.length == 0 || this.search.trim().length > 0) {
                    this.loading = true
                    this.getAffiliateList({
                        "search": this.search,
                        "limit": this.limit,
                        "page": this.page
                    });
                }
            }, 1000); // 1200ms delay
        },
        onClearSearch() {
            clearTimeout(this.debounceTimer);
            // Start new debounce timer

            this.page = 1
            this.search = ''
            this.loading = true
            this.getAffiliateList({
                "search": this.search,
                "limit": this.limit,
                "page": this.page
            });

        },

        updateList() {
            clearTimeout(this.debounceTimer);
            // Start new debounce timer

            this.page = 1
            this.search = ''
            this.loading = true
            this.getAffiliateList({
                "search": this.search,
                "limit": this.limit,
                "page": this.page
            });
        },
        onLimitChange(newLimit) {
            this.limit = newLimit;
            this.page = 1;
            this.loading = true;
            this.getAffiliateList({
                search: this.search,
                limit: this.limit,
                page: this.page,
            });
        },
        addClicked() {
            this.$refs.addAffiliateModal.
                openModal()

        },

        onActionClicked(data, option) {
            if (option == 'Active') {
                this.$dialog.show({
                    title: "Update",
                    text: "Are you sure you want to update status?",
                    onConfirm: () => {
                        this.updateAffiliateStatus({
                            id: data.id,
                            status: 1
                        }) 
                    },
                });
            } else if (option == 'Inactive') {
                this.$dialog.show({
                    title: "Update",
                    text: "Are you sure you want to update status?",
                    onConfirm: () => {
                        this.updateAffiliateStatus({
                            id: data.id,
                            status: 0
                        }) 
                    },
                });
            } 
            else if (option == 'Edit') {
                this.$refs.addAffiliateModal.
                editModal(data)
            }
          
        }



    },
};
</script>
